<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="(empCourse.id ? 'Edit Employee Course: ' + empCourse.id : 'New Employee Course') + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/training-courses`">
                            <i class="fa fa-graduation-cap"></i> Training Courses
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/training-courses/view/${course.id}`">
                            {{ course.course_name }}
                        </router-link>
                    </li>
                    <template v-if="empCourse.id">
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/training-courses/employee/${empCourse.id}/view`">
                                {{ empCourse.completed_at | moment("MM/DD/YYYY") }} by {{ empCourse.FirstName }} {{ empCourse.LastName }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">
                            <i class="fa fa-edit"></i> Edit
                        </li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item active">
                            New Employee Course
                        </li>
                    </template>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-lg-10 col-md-12">
                    <div class="card mb-3">
                        <div class="card-header">Employee Course</div>
                        <div class="card-body">

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.employee_id }" class="row">
                                <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.employee_id}">
                                    Employee:
                                    <i class="fa fa-asterisk text-danger" v-if="empCourse.is_non_employee !== true"></i>
                                </label>
                                <div class="col-md-8 col-sm-12">
                                    <employee-select ref="employeeSelector" :selectedValues="EmployeeValues" @vselected="onEmployeeSelect" :hasError="errors.employee_id ? true : false"></employee-select>

                                    <div v-if="errors.employee_id" class="text-danger">
                                        <span v-for="error in errors.employee_id">{{ error }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true}">
                                    Non-Employee:
                                </label>
                                <div class="col-md-8 col-sm-12">
                                    <b-form-checkbox v-model="empCourse.is_non_employee" :value="true" :unchecked-value="false" plain />
                                </div>
                            </div>

                            <template v-if="empCourse.is_non_employee === true">
                                <div class="form-group row">
                                    <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.person_name}">
                                        Non-Employee Name:
                                        <i class="fa fa-asterisk text-danger"></i>
                                    </label>
                                    <div class="col-md-8 col-sm-12">
                                        <b-form-input v-model="empCourse.person_name" placeholder="Enter Non-Employee Name" />

                                        <div v-if="errors.person_name" class="text-danger">
                                            <span v-for="error in errors.person_name">{{ error }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.person_company}">
                                        Non-Employee Company:
                                        <i class="fa fa-asterisk text-danger"></i>
                                    </label>
                                    <div class="col-md-8 col-sm-12">
                                        <b-form-input v-model="empCourse.person_company" placeholder="Enter Non-Employee Company" />

                                        <div v-if="errors.person_company" class="text-danger">
                                            <span v-for="error in errors.person_company">{{ error }}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <div class="form-group row">
                                <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.jobsite_id}">
                                    Jobsite:
                                </label>
                                <div class="col-md-8 col-sm-12">
                                    <jobsite-select :selectedValues="JobsiteValues" @vselected="onJobSiteSelectUpdate" :hasError="errors.jobsite_id ? true : false"></jobsite-select>

                                    <div v-if="errors.jobsite_id" class="text-danger">
                                        <span v-for="error in errors.jobsite_id">{{ error }}</span>
                                    </div>
                                </div>
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.completed_at }" class="row">
                                <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.completed_at}">
                                    Completed Date:
                                </label>
                                <div class="col-md-8 col-sm-12">
                                    <div class="input-group">
                                        <date-picker v-model="empCourse.completed_at" :config="{format: 'MM/DD/YYYY', useCurrent: false}" :class="{ 'is-invalid': errors.completed_at }" placeholder="Course Date"></date-picker>
                                        <div class="input-group-btn">
                                            <button type="button" class="btn btn-default" v-on:click="empCourse.completed_at = null;" title="Remove Completed Date"><i class="fa fa-remove text-danger"></i></button>
                                        </div>
                                    </div>

                                    <div v-if="errors.completed_at" class="text-danger mt-1">
                                        <span v-for="error in errors.completed_at">{{ error }}</span>
                                    </div>

                                    <div class="alert alert-warning mt-2">
                                        Leaving the Completed Date blank will register this course as Pending Completion for the employee.
                                    </div>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.expires_at }" class="row">
                                <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.expires_at}">
                                    Expire Date:
                                </label>
                                <div class="col-md-8 col-sm-12">
                                    <div class="input-group">
                                        <date-picker v-model="empCourse.expires_at" :config="{format: 'MM/DD/YYYY', useCurrent: false}" :class="{ 'is-invalid': errors.expires_at }" placeholder="Expire Date"></date-picker>
                                        <div class="input-group-btn">
                                            <button type="button" class="btn btn-default" v-on:click="empCourse.expires_at = null;" title="Remove Expire Date"><i class="fa fa-remove text-danger"></i></button>
                                        </div>
                                    </div>

                                    <template v-if="suggestedExpirationDate">
                                        Suggested Expiration Date: <a href="javascript:void(0)" class="mt-1" v-on:click="useSuggestedExpiration()">{{ suggestedExpirationDate }}</a>
                                        <i class="fa fa-question-circle" :title="`Based on the Course Validity Setting of ${course.valid_days} Days from Completed Date`"></i>
                                    </template>

                                    <div v-if="errors.expires_at" class="text-danger">
                                        <span v-for="error in errors.expires_at">{{ error }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header">
                            <strong><i class="fa fa-files-o"></i> Files &amp; Photos</strong>
                        </div>
                        <div class="card-body">
                            <template v-if="empCourse.id">
                                <file-uploader assetType="EmployeeTrainingCourse" :assetId="empCourse.id" />
                                <hr/>

                                <file-list :files="files" />
                            </template>
                            <template v-else>
                                <div class="alert alert-info">
                                    In order to better process file uploads, you must first save the Employee Training Course before uploading files
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-success mt-4" v-on:click="upsertCourseEmployee(this)" :disabled="saving">
                <span v-if="empCourse.id">Update</span>
                <span v-else>Create</span>
                Employee Course
            </button>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                courseId: this.$route.params.courseId,
                empCourseId: this.$route.params.empCourseId,
                course: {},
                files: [],
                empCourse: {},
                errors: {},
                suggestedExpirationDate: null,
            }
        },

        computed: {
            EmployeeValues(){
                //check for null
                if(!this.empCourse.employee_id)
                {
                    return {};
                }

                return {EmployeeId: this.empCourse.EmployeeId, FirstName: this.empCourse.FirstName, LastName: this.empCourse.LastName, EmployeeNumber: this.empCourse.EmployeeNumber};
            },

            JobsiteValues(){
                if(!this.empCourse.jobsite_id)
                {
                    return null;
                }

                //Send it
                return {JobsiteId: this.empCourse.jobsite_id, JobsiteName: this.empCourse.JobsiteName, JobsiteNumber: this.empCourse.JobsiteNumber};
            },

            completedNow(){
                //Setup
                var completedDate = moment().format('MM/DD/YYYY');

                //Set it
                return completedDate;
            },
        },

        watch: {
            'empCourse.completed_at'(newVal, oldVal){
                //IF the expire date is NOT null, stop
                if(!this.course.valid_days || !newVal)
                {
                    return;
                }

                //Increment the Date
                var completedDate = moment(newVal, 'MM/DD/YYYY');

                //Add the number of days
                completedDate.add(this.course.valid_days, 'days');

                //Set it
                this.suggestedExpirationDate = completedDate.format('MM/DD/YYYY');
            },

            'empCourse.is_non_employee'(newVal, oldVal){
                //IF the value is true, clear the employee input
                if(newVal === true)
                {
                    //Clear
                    this.$refs.employeeSelector.clearInput();
                }
            }
        },

        methods: {

            getEmpTrainingCourse() {
                //Get the data
                this.$http
                    .get('/training-courses/employee/'+this.courseId+ (this.empCourseId ? '/' + this.empCourseId : ''))
                    .then(response => {
                        //Set all the data
                        this.course = response.data.course;
                        this.empCourse = response.data.empCourse;
                        this.files = response.data.files;

                        //Check for Null
                        // if(!this.empCourse.employee_id && this.empCourse.id)
                        // {
                        //     this.empCourse.is_non_employee = true;
                        // }
                        // else
                        // {
                        //     this.empCourse.is_non_employee = false;
                        // }
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            upsertCourseEmployee() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('/training-courses/employee/'+this.courseId, this.empCourse)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Training Course Saved');

                    //Check it
                    if(this.empCourse.id)
                    {
                        //Return to main list?
                        this.$router.push('/training-courses/view/' + this.courseId);
                    }
                    else
                    {
                        //Send to edit page
                        this.$router.push('/training-courses/employee/'+ this.courseId +'/' + response.data.id);
                    }
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            onEmployeeSelect(employee){
                if (employee == null)
                {
                    this.empCourse.employee_id = null;
                    this.$set(this.empCourse, 'EmployeeFirstName', null);
                    this.$set(this.empCourse, 'EmployeeLastName', null);
                    this.$set(this.empCourse, 'EmployeeAddress', null);
                    this.$set(this.empCourse, 'EmployeeCity', null);
                    this.$set(this.empCourse, 'EmployeeState', null);
                    this.$set(this.empCourse, 'EmployeeZip', null);
                    this.$set(this.empCourse, 'EmployeePhone', null);
                    this.$set(this.empCourse, 'EmployeeTitle', null);

                    return;
                }

                //Set the ID
                this.empCourse.employee_id = employee.EmployeeId;

                //Reactivity Helper
                this.$set(this.empCourse, 'EmployeeFirstName', employee.FirstName);
                this.$set(this.empCourse, 'EmployeeLastName', employee.LastName);
                this.$set(this.empCourse, 'EmployeeAddress', employee.Address);
                this.$set(this.empCourse, 'EmployeeCity', employee.City);
                this.$set(this.empCourse, 'EmployeeState', employee.State);
                this.$set(this.empCourse, 'EmployeeZip', employee.Zip);
                this.$set(this.empCourse, 'EmployeePhone', employee.Phone);

                //Check for a TitleName
                if (employee.TitleName)
                {
                    this.$set(this.empCourse, 'EmployeeTitle', employee.TitleName);
                }
                else
                {
                    this.$set(this.empCourse, 'EmployeeTitle', employee.position);
                }
            },

            //On Select
            onJobSiteSelectUpdate(jobsite){
                //Check for null
                if(jobsite == null)
                {
                    this.empCourse.jobsite_id = null;
                }

                //Set the ID
                this.empCourse.jobsite_id = jobsite.JobsiteId;
            },

            useSuggestedExpiration(){
                //Set it
                this.empCourse.expires_at = this.suggestedExpirationDate;

                //Force update
                this.$forceUpdate();
            },

            forceUpdate(){
                //Force update
                this.$forceUpdate();
            },
        },

        mounted() {
            //Get the Training Course
            this.getEmpTrainingCourse();
        }
    }
</script>
